import { IntroductionCard } from './IntroductionCard';

export function LandingIntroCard() {
  return (
    <div className="bg-[#0c1222]/80 backdrop-blur border border-[#1a2d4d] rounded-xl p-6 shadow-lg text-center">
      {/* Main Title with Logo */}
      <div className="flex flex-col sm:flex-row justify-center items-center mb-4 sm:mb-6 lg:mb-8">
        <img
          src="/images/WIA Logo.png"
          alt="Writing Interactive Academy Logo"
          className="h-12 sm:h-14 lg:h-16 xl:h-20 mb-3 sm:mb-0 sm:mr-4"
        />
        <div className="text-center sm:text-left">
          <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#4f46e5] via-[#06b6d4] to-[#10b981] leading-tight">
            Writing the A-B-A Scene
          </h1>
          <h2 className="text-xs sm:text-sm lg:text-base xl:text-lg 2xl:text-xl font-medium text-gray-300 mt-1">
            Game Lab 101: Scene-Writing Editor
          </h2>
        </div>
      </div>

      {/* Divider */}
      <div className="w-12 sm:w-16 lg:w-20 xl:w-24 h-px bg-gradient-to-r from-[#4f46e5] to-[#06b6d4] mx-auto mb-4 sm:mb-6"></div>

      {/* Description Card */}
      <div className="mb-6 sm:mb-8">
        <IntroductionCard />
      </div>

      {/* Process Steps */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
        <div className="bg-[#0c1222]/80 backdrop-blur border border-[#1a2d4d] rounded-xl p-3 sm:p-4 hover:bg-[#0c1222] transition-colors duration-200">
          <div className="text-[#4f46e5] font-semibold text-sm sm:text-base mb-1 sm:mb-2">
            1. PLAN
          </div>
          <div className="text-gray-400 text-xs sm:text-sm">
            Choose a dynamic for your two characters and plan the reason for their conversation. Who
            are they, where are they, what do they want?
          </div>
        </div>

        <div className="bg-[#0c1222]/80 backdrop-blur border border-[#1a2d4d] rounded-xl p-3 sm:p-4 hover:bg-[#0c1222] transition-colors duration-200">
          <div className="text-[#06b6d4] font-semibold text-sm sm:text-base mb-1 sm:mb-2">
            2. WRITE
          </div>
          <div className="text-gray-400 text-xs sm:text-sm">
            {`Write the other character's dialogue and set the scene in the non-interactive text
            leading up to each moment of decision`}
          </div>
        </div>

        <div className="bg-[#0c1222]/80 backdrop-blur border border-[#1a2d4d] rounded-xl p-3 sm:p-4 hover:bg-[#0c1222] transition-colors duration-200">
          <div className="text-[#10b981] font-semibold text-sm sm:text-base mb-1 sm:mb-2">
            3. DESIGN
          </div>
          <div className="text-gray-400 text-xs sm:text-sm">
            Use the visual narrative tree to create choices with a variety of patterns mixing game
            design and social dynamics
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingIntroCard;
